<template>
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card title="Transporter" class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">Transporter</h4>
                    </div>
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm" v-show="editMode">Save</vs-button>
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="editForm" v-show="!editMode">Edit</vs-button>
                </div>
                <div class="vx-row mt-6">
                    <div class="vx-col md:w-1/2 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input disabled class="w-full" label="ID *" v-model="data.id" />
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="Transporter Code *" v-model="data.transporter_code" :disabled="editMode ? false : true"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="Name" v-model="data.name" :disabled="editMode ? false : true"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="address_1 " v-model="data.address_1" :disabled="editMode ? false : true"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="address_2 " v-model="data.address_2" :disabled="editMode ? false : true"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="PIC" v-model="data.pic" :disabled="editMode ? false : true"/>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="Email" v-model="data.email" :disabled="editMode ? false : true"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="Phone" v-model="data.phone" :disabled="editMode ? false : true"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-full">
                                <label for="" class="vs-input--label">Area ID *</label>
                                <v-select :options="areaOptions" v-model="data.area_id" label="name" :reduce="area_id => area_id.id" @search="searchArea" :disabled="editMode ? false : true"></v-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="City" v-model="data.city" :disabled="editMode ? false : true"/>
                            </div>
                        </div>
                        <div class="vx-row mb-4">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="Post Code *" v-model="data.post_code" :disabled="editMode ? false : true"/>
                            </div>
                        </div>
                    </div>
                </div>
            </vs-card>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import InboundItem from '@/components/InboundItem.vue'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    // import ClientVue from './Client.vue';


    export default {
        components:{
            vSelect,
            flatPickr,
            InboundItem
        },
        data(){
            return {
                isLoading: false,
                data: null,
                areaOptions: [],
                clientTypeOptions: [],
                maxRetry: 10,
                editMode: false,
            }
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            }
        },
        methods:{
            fetchData() {
                this.isLoading = true
                this.maxRetry = this.maxRetry - 1
                this.$http.get('master/transporters/' + this.$route.params.id)
                .then(transporters => {
                    this.areaOptions = [transporters.data.areas]
                    this.clientTypeOptions = [transporters.data.client_types]
                    this.data = transporters.data
                    setTimeout(() => {
                        this.isLoading = false
                    }, 500)
                })

                //  Promise.all([this.fetchData('master/areas/filter/getlist'), this.fetchData('master/clients'), this.fetchData('master/bptypes'), this.fetchData('master/subarea')] + this.$route.params.id)
                // .then(this.$http.spread((areas, clients, bptypes, subareas) => {
                //     this.areaOptions = areas.data
                //     this.subAreaOptions = subareas.data
                //     this.bpTypeOptions = bptypes.data
                //     this.clientCodeOptions = clients.data.data
                //     this.data = customer.data
                //     setTimeout(() => {
                //         this.isLoading = false
                //     }, 500)
                // }))
                .catch(() => {
                    if(this.maxRetry == 0){
                        this.isLoading = false
                        this.$vs.dialog({
                            type: 'confirm',
                            color: 'danger',
                            title: 'Server Error',
                            text: 'Try again?',
                            accept: () => {
                                this.fetchData()
                                this.maxRetry = 10
                            },
                            cancel: () => this.$router.go(-1),
                            acceptText: 'Yes',
                            cancelText: 'No'
                        });
                        return;
                    }
                    this.fetchData()
                })
            },
            // fetchAllData() {
            //     this.isLoading = true
            //     this.maxRetry = this.maxRetry - 1
            //     Promise.all([this.fetchData('master/areas/filter/getlist'), this.fetchData('master/clients'), this.fetchData('master/bptypes'), this.fetchData('master/subarea')])
            //     .then(this.$http.spread((areas, clients, bptypes, subareas) => {
            //         this.areaOptions = areas.data
            //         this.subAreaOptions = subareas.data
            //         this.bpTypeOptions = bptypes.data
            //         this.clientCodeOptions = clients.data.data
            //         setTimeout(() => {
            //             this.isLoading = false
            //         }, 500)
            //     }))
            //     .catch(() => {
            //         if(this.maxRetry == 0){
            //             this.isLoading = false
            //             this.$vs.dialog({
            //                 type: 'confirm',
            //                 color: 'danger',
            //                 title: 'Server Error',
            //                 text: 'Try again?',
            //                 accept: () => {
            //                     this.fetchAllData()
            //                     this.maxRetry = 10
            //                 },
            //                 cancel: () => this.$router.go(-1),
            //                 acceptText: 'Yes',
            //                 cancelText: 'No'
            //             });
            //             return;
            //         }
            //         this.fetchAllData()
            //     })
            // },
            searchArea(search, loading) {
                if(search.length > 2){
                    loading(true)
                    const data = {
                        name: search
                    }
                    this.$http.post('master/areas/filter/search', data)
                    .then(res => {
                        this.areaOptions = res.data
                        loading(false)
                    })
                    .catch(() => {
                        this.searchArea(search, loading)
                    })
                }
            },
            submitForm() {
                this.isLoading = true
                this.$http.put('master/transporters/' + this.$route.params.id + '/update', this.data)
                .then(res => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Saved Successfully',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Transporter updated successfully'
                    })
                    this.$router.push({ path: '/master/transporter' })
                })
                .catch(error => {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error saving',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Error saving'
                    })
                })
                .then(() => {
                    this.isLoading = false
                })
            },
            back() {
                if(this.editMode) {
                    this.$vs.dialog({
                        color: 'warning',
                        title: 'Leave Page',
                        text: 'Changes you made may not be saved?',
                        acceptText: 'Leave Page',
                        accept: () => { this.$router.go(-1) },
                    })
                }
                else{
                    this.$router.go(-1)
                }
            },
            editForm() {
                // this.editMode = true
                this.isLoading = true
                this.maxRetry = this.maxRetry - 1

                Promise.all([this.$http.get('master/areas/filter/getlist'), this.$http.get('master/clients'), this.$http.get('master/bptypes'), this.$http.get('master/subarea')])
                .then(this.$http.spread((areas, clients, bptypes, subareas) => {
                    this.areaOptions = areas.data
                    this.subAreaOptions = subareas.data
                    this.bpTypeOptions = bptypes.data
                    this.clientCodeOptions = clients.data.data

                    setTimeout(() => {
                        this.editMode = true
                        this.isLoading = false
                    }, 500)
                    
                }))
                .catch(() => {
                    if(this.maxRetry < 0){
                        this.isLoading = false
                        this.$vs.dialog({
                            type: 'confirm',
                            color: 'danger',
                            title: 'Server Errorrrr',
                            text: 'Try again?',
                            accept: () => {
                                this.editForm()
                                this.maxRetry = 10
                            },
                            acceptText: 'Yes',
                            cancelText: 'No'
                        })
                        return;
                    }
                    this.editForm()
                })
            }
        },
        mounted(){
            this.fetchData()
        },
    }
</script>